import { Flex, Button } from 'antd'
import {
  LargeMailIcon,
  CenteredTitle,
  FullWidthAlert,
  CenteredText,
} from './styles/EmailConfirmationStyles'

interface EmailConfirmationProps {
  onBackToLogin: () => void
}

export function EmailConfirmation({ onBackToLogin }: EmailConfirmationProps) {
  return (
    <Flex vertical gap="large" align="center">
      <LargeMailIcon />
      <CenteredTitle level={2}>Check Your Email</CenteredTitle>
      <FullWidthAlert
        message="Account Created Successfully!"
        description="We've sent you a confirmation email. Please check your inbox and click the confirmation link to activate your account."
        type="success"
        showIcon
      />
      <CenteredText type="secondary">
        Didn't receive the email? Check your spam folder or contact support.
      </CenteredText>
      <Button onClick={onBackToLogin}>Back to Login</Button>
    </Flex>
  )
}
